/* eslint-disable no-use-before-define */
import { ajax, arrayFrom, sortFn, } from '../twd'

export const getHoldings = async () => {
    const {data} = ajax({
        url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
        method: 'GET'
    })
    const rs = await data
    const now = new Date()
    const hs = arrayFrom(rs.holdings)
        .map(a => {
            let m = a.maturity
            if (!m) return a

            let d = new Date(m)
            if (!isNaN(d) && m.indexOf('T')<0 && m.split('-').length===3) {
                a.maturity = m + 'T00:00:00'
            }
            return a
        })
        .filter(({maturity}) => {
            const d = new Date(maturity)
            return d && d>=now
        })
        .sort(sortFn((a) => a.maturity ? new Date(a.maturity) : Number.POSITIVE_INFINITY))        

    return hs
}
